import React, { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

const isSupportNativeLazylaod = 'loading' in HTMLImageElement.prototype;

export default function LazyLoadImg({ src, alt, enableLazyLoad = false, ...restProps }) {
    const imgRef = useRef(null);
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '50px 0%',
        threshold: [0, 0.5, 1],
        skip: isSupportNativeLazylaod || !enableLazyLoad
    });
    const canSetSrc = isSupportNativeLazylaod || !enableLazyLoad || inView;
    const imgProps = (() => {
        let props = {};
        if (isSupportNativeLazylaod) {
            props.loading = 'lazy';
        }
        if (canSetSrc) {
            props.src = src;
        }
        return props;
    })();

    useEffect(() => {
        if (imgRef.current) {
            imgRef.current.classList.add('fever-anim-gradient-bg');
            imgRef.current.addEventListener('load', handleLoad);
        }
        function handleLoad() {
            if (imgRef.current) {
                imgRef.current.classList.remove('fever-anim-gradient-bg');
                imgRef.current.removeEventListener('load', handleLoad);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <img
            ref={node => {
                imgRef.current = node;
                ref(node);
            }}
            alt={alt}
            {...imgProps}
            {...restProps}
        />
    );
}
